import { hasGroupByParentAll } from 'modelInterface/graph/utils';
import type { DependencyMapGroupingData } from './types';

export const shouldStartPathsAfterParentChildHops = ({
  hasUserDefinedReferenceTypeGroups,
  appliedGroupingRules,
}: DependencyMapGroupingData): boolean =>
  !hasUserDefinedReferenceTypeGroups &&
  hasGroupByParentAll(appliedGroupingRules);
